import {OverlayTrigger, Tooltip} from "react-bootstrap";
import React from "react";
const ClientCrudTableRowModal2 = ({el, i, desvinculedLine}) => {
    let {/* code, */ documentClient, number, type/* , _id */} = el;
  
    const handleChangeSelect = () => {
        desvinculedLine(number, documentClient, el);
        }
    return (
        <tr>
            <th scope="row">{i + 1}</th>
            <td className="text-center">{documentClient}</td>
            <td className="text-center">{number}</td>
            <td className="text-center">{type}</td>
            <td className="text-center">
                <OverlayTrigger placement="top"
                                overlay={<Tooltip id="tooltip-top">Desvincular Línea</Tooltip>}>
                    <button type="button" 
                            className="btn btn-sm btn-danger"
                            onClick={handleChangeSelect}>
                        <i className="bi bi-trash"/>
                    </button>
                </OverlayTrigger>
            </td>
        </tr>
    );
}
export default ClientCrudTableRowModal2;
